import { createGlobalStyle } from 'styled-components';
import backgroundImage from './images/background.jpg';

export const GlobalStyle = createGlobalStyle`
  :root {
    --maxWidth: 1280px;
    --white: #feffff;
    --black: #1d202b;
    --lightGrey: #eee;
    --medGrey: #353535;
    --darkGrey: #1c1c1c;
    --silver: #f0f0f1;
    --brandPrimary: #FC8EAC;
    --brandSecondary: #FF0266;
    --fontSuperBig: 2.5rem;
    --fontBig: 1.5rem;
    --fontMed: 1.2rem;
    --fontSmall: 1rem;
  }

  * {
    box-sizing: box-border;
    /*font-family: 'Abel', sans-serif;*/
  }

  body {
    padding: 0;
    margin: 0;
    background-color: var(--white);
    background-image: url(${backgroundImage});
    background-size: 100%;

    h1 {
      font-size: 2rem;
      font-weight: 600;
      color: var(--black);
    }

    h3 {
      font-size: 1.1rem;
      font-weight: 600;
    }

    p {
      font-size: 1rem;
      color: var(--darkGrey);
    }

    footer {
      position: absolute;
    }
  }
`;
